// removed by extract-text-webpack-plugin
module.exports = {"likers-list":"likers-modal__likers-list__Oishx","no-likers":"likers-modal__no-likers__XeszJ","liker":"likers-modal__liker__1_eIN","name":"likers-modal__name__2Awi8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/likers-modal.scss
// module id = 1418
// module chunks = 1